<app-modalbase [title]="'Cambiar de workspace' | translate" [primaryBtnLabel]="'Continuar' | translate"
  [secondaryBtnLabel]="'Cancelar' | translate" [primaryBtnDisabled]="!selectedWorkspaceId()" (close)="close()"
  (secondaryClick)="close()" (primaryClick)="onContinue()">

  <div class="switch-workspace-content">
    <p class="modal-subtitle">
      {{ 'Selecciona el espacio en el que vas a trabajar' | translate }}
    </p>

    <div class="workspace-list">
      @for (workspace of workspaces; track workspace.id) {
      <app-workspace-option mode="switch" [workspace]="workspace" [selected]="isSelected(workspace)"
        [active]="isCurrentWorkspace(workspace)" (selectWorkspace)="onSelectWorkspace($event)" />
      }
    </div>
  </div>

</app-modalbase>
